
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/[module]/[section]/[lesson]",
      function () {
        return require("private-next-pages/tutorials/[module]/[section]/[lesson]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/[module]/[section]/[lesson]"])
      });
    }
  